var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_vm._m(0),_c('HelpList')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticStyle:{"display":"flex","align-items":"flex-end"}},[_c('span',{staticStyle:{"font-size":"20px","color":"#fff"}},[_vm._v("帮助中心")])]),_c('span',{staticStyle:{"margin-top":"10px","font-size":"14px","color":"#fff"}},[_vm._v("help center")])])
}]

export { render, staticRenderFns }